import { Entity, EntityRepositoryType, PrimaryKey, Property, Enum, Unique } from '@mikro-orm/postgresql'
import { EntityRepository } from '@mikro-orm/postgresql'
import { v4 as uuid } from 'uuid'
import { BaseEntity } from '../core/core.entities'
import { InvitationRole } from '../../../../shared/types/account-types'

export enum InvitationStatus {
	DRAFT = 'DRAFT',
	SENT = 'SENT',
	ACCEPTED = 'ACCEPTED',
	EXPIRED = 'EXPIRED',
	CANCELLED = 'CANCELLED',
	MYS_SUCCESS_BUT_PEAK_FAILED = 'MYS_SUCCESS_BUT_PEAK_FAILED',
}

class InvitationRepository extends EntityRepository<Invitation> {}

@Entity()
export class Invitation extends BaseEntity {
	[EntityRepositoryType]?: InvitationRepository

	@PrimaryKey()
	id: string = uuid()

	@Property()
	clientId: string

	@Property()
	inviterServiceProviderId: string

	@Property()
	inviterUserId: string

	@Property({ nullable: true })
	inviteeUserId?: string // User ID of the created user (trade hub user or service provider user account)

	@Property()
	@Unique()
	email: string

	@Property({ nullable: true })
	firstName?: string

	@Property({ nullable: true })
	lastName?: string

	@Property()
	preferredLocale: string

	@Enum(() => InvitationRole)
	role: InvitationRole

	@Enum(() => InvitationStatus)
	status: InvitationStatus = InvitationStatus.SENT

	@Property()
	tokenHash: string

	@Property()
	expiresAt: Date

	@Property({ nullable: true })
	acceptedAt?: Date

	@Property({ nullable: true })
	lastEmailSentAt?: Date

	@Property({ default: 1 })
	emailSendCount: number = 1

	@Property({ nullable: true })
	b2bPartnerUserId?: string

	@Property({ nullable: true })
	peakCustomerId?: string
}


